import FieldDefs from './SitePagesFieldDefs'
import {doLangFields} from '../../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.group_report.sitepages", FieldDefs),
            sortOrder: [
                {
                    field: 'it50',
                    direction: 'desc'
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
